import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  // AppService.start();
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component, route }) => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
        key: route.meta?.unique ? route.fullPath : null,
        "data-slug": route.meta?.unique ? route.fullPath : '',
        class: "default"
      }, null, 8, ["data-slug"]))
    ]),
    _: 1
  }))
}
}

})